import "./Hero.css";
import {
  FaArrowRight,
  FaCheckCircle
} from "react-icons/fa";

function Hero() {

  return (

<section className="hero">

<div className="container">

<div className="row align-items-center">

<div className="col-lg-6">

<div className="hero-content">

<span className="hero-badge">

🚀 Welcome to Potech Technologies

</span>

<h1>

Building
<span> Modern Websites </span>

&
Software Solutions
For Growing Businesses

</h1>

<p>

Potech Technologies provides professional Website Development,
Custom Software Development, ERP Solutions, E-Commerce,
Business Automation and IT Services to help your business grow digitally.

</p>

<div className="hero-btns">

<a href="#contact" className="btn-main">

Get Started

<FaArrowRight className="ms-2"/>

</a>

<a href="#services" className="btn-outline">

Our Services

</a>

</div>

<div className="hero-features">

<div>

<FaCheckCircle/>

Business Website

</div>

<div>

<FaCheckCircle/>

ERP Software

</div>

<div>

<FaCheckCircle/>

E-Commerce

</div>

</div>

</div>

</div>

<div className="col-lg-6">

<div className="hero-right">

<div className="circle circle1"></div>

<div className="circle circle2"></div>

<div className="hero-card">

<h3>

Potech Technologies

</h3>

<p>

Website Development

</p>

</div>

<div className="hero-card card2">

<h3>

Software Development

</h3>

<p>

Business Automation

</p>

</div>

<div className="hero-card card3">

<h3>

24×7

</h3>

<p>

Support

</p>

</div>

</div>

</div>

</div>

</div>

</section>

  )

}

export default Hero;